import React, { useContext, useEffect } from 'react';
import { useRouter } from 'next/router';

import { LoadingDots } from '@reckon-web/loading';
import { Flex } from '@reckon-web/flex';
import { Notice } from '@reckon-web/notice';

import { IdContext } from '../context';
import { AuthenticatedUsers } from '../components/authentication/authenticatedUsers';
import { useAuthenticatedUser } from '../components/hooks';
import { useFederatedUser } from '../components/authentication/useFederatedCallback';
import { Layout } from '../components/layout/layout';
import { useNavigationWithQuery } from '../components/authentication/useNavigationWithQuery';
import { useRedirectToClient } from '../components/authentication/useRedirectToClient';

/* const idTokenRegex = new RegExp('id_token=(.*?)&');
const accessTokenRegex = new RegExp('access_token=(.*?)&');
// const errorRegex = new RegExp('error_description=(.*?)&');
const refreshTokenRegex = new RegExp('refresh_token=(.*?)&');
// const redirectRegex = new RegExp('redirect=(.*?)&');
// const clientIdRegex = new RegExp('client_id=(.*?)&'); */

const Index = () => {
  const router = useRouter();
  const {
    clientId,
    redirectURL,
    tenancy: TENANCY,
    product,
    clientState,
  } = useContext(IdContext);
  const { authenticationStatus, authenticatedUser } = useAuthenticatedUser({
    checkMFAValidation: true,
  });
  const { federatedStatus, federatedUser, error } = useFederatedUser();
  const { navigateTo } = useNavigationWithQuery();
  const { redirectToClient, redirectingToClient } = useRedirectToClient();

  const federatedCallback =
    router.asPath && router.asPath.includes('#')
      ? `#${router.asPath.split('#')[1]}`
      : '';

  useEffect(() => {
    if (federatedCallback) {
      if (federatedUser && federatedStatus === 'authenticated') {
        redirectToClient();
      } else if (federatedStatus === 'MFAValidateRequired') {
        navigateTo({
          path: 'verifycode',
          query: {
            client_id: clientId,
            redirect_uri: redirectURL,
            state: clientState,
          },
        });
      } else if (['MFASetupRequired', 'signUp'].includes(federatedStatus)) {
        navigateTo({
          path: 'mfa',
          query: {
            client_id: clientId,
            redirect_uri: redirectURL,
            state: clientState,
          },
        });
      }
    } else {
      if (authenticationStatus === 'unauthenticated') {
        navigateTo({ path: 'login' });
      } else if (authenticationStatus === 'notMFAValidated') {
        navigateTo({
          path: 'signout',
          query: {
            relogin: 1, // To ensure signout doesnt redirect to app for APS
          },
        });
      } else if (authenticationStatus === 'requireMFASetup') {
        navigateTo({
          path: 'signout',
          query: {
            relogin: 1, // To ensure signout doesnt redirect to app for APS
          },
        });
      } else if (
        authenticationStatus === 'authenticated' &&
        authenticatedUser &&
        router.query.prompt === 'none' &&
        !redirectingToClient
      ) {
        redirectToClient();
      }
    }
  });

  if ((!authenticatedUser && !federatedUser && !error) || redirectingToClient) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <LoadingDots label="" />
      </Flex>
    );
  }

  return (
    <Layout theme={TENANCY} product={product}>
      {error && <Notice tone="critical">{error}</Notice>}
      {authenticatedUser?.attributes && (
        <AuthenticatedUsers
          users={[
            {
              emailOrUsername: authenticatedUser?.attributes?.email,
              firstName: authenticatedUser?.attributes?.given_name,
              lastName: authenticatedUser?.attributes?.family_name,
              onClick: () => redirectToClient(),
            },
          ]}
          signInDifferentAccount={() =>
            navigateTo({
              path: 'signout',
              query: {
                relogin: 1, // To ensure signout doesnt redirect to app for APS
              },
            })
          }
        />
      )}
    </Layout>
  );
};

export default Index;
